import { createApp } from "vue";
import { createPinia } from 'pinia';
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
// import store from "./store";
import Toast, { type PluginOptions, type POSITION } from "vue-toastification";
import 'hammerjs';
import { createI18n } from 'vue-i18n';
import 'devextreme/dist/css/dx.light.css';

import "@/assets/css/App.scss";
import "@/assets/css/tailwind.css";
// import "@popperjs/core";
// import "bootstrap";

import "vue-toastification/dist/index.css";
import "@/assets/css/site.css";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import localCurrency from "cldr-numbers-full/main/tr/currencies.json";
import numbers from "cldr-numbers-full/main/tr/numbers.json";
import caGregorian from "cldr-dates-full/main/tr/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/tr/dateFields.json";
import tr from "@/locales/tr.json";
import en from "@/locales/en.json";
import "@fontsource/roboto" 
import { useErrorStore } from '@/stores/error';
import type { ErrorInfo } from '@/types/ErrorModel';
import { defaultLocale, localeOptions } from '@/constants/config';
import 'shepherd.js/dist/css/shepherd.css';
import 'driver.js/dist/driver.css';
import * as trMessages from "devextreme/localization/messages/tr.json";
import { getBrandMetadata } from "@/utils/branding";
import {
  locale as lokal,
  loadMessages,
  formatMessage,
} from "devextreme/localization";

import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-license';
 
config({ licenseKey });   

lokal("tr");
loadMessages(trMessages);

const app = createApp(App);
const pinia = createPinia();

app.use(pinia).use(router);

const messages = {
  en,
  tr,
};

const savedLocale = (localStorage.getItem('orionLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('orionLanguage')).length > 0) ? localStorage.getItem('orionLanguage') : defaultLocale;

const i18n = createI18n({
  locale: savedLocale ?? 'tr',
  fallbackLocale: 'tr',
  messages,
});

app.use(i18n);

const options: PluginOptions = {
  position: "bottom-right" as POSITION.BOTTOM_RIGHT,
  timeout: 3500,
  closeOnClick: false,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  //transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true,
};
app.use(Toast, options);

app.config.errorHandler = (err, vm, info) => {
  const er = err as TypeError;
  const errorStore = useErrorStore();
  const errorInfo: ErrorInfo = {
    ErrorType: 'Error',
    ErrorText: er.message
  };
  errorStore.setError(errorInfo);
};

app.mount("#app");

(() => {
  const { companyName, favicon } = getBrandMetadata();

  const setFavicon = (href: string) => {
    const existing = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    const linkEl = existing ?? document.createElement('link');
    linkEl.rel = 'icon';

    if (href.endsWith('.png')) linkEl.type = 'image/png';
    else if (href.endsWith('.svg')) linkEl.type = 'image/svg+xml';
    else linkEl.type = 'image/x-icon';
    linkEl.href = href;
    if (!existing) document.head.appendChild(linkEl);
  };

  document.title = companyName;
  setFavicon(favicon || "/favicon.svg");
})();
